import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { getActiveContext, subscribe } from '@/lib/active-context-store';
const PREFIX = 'expenses-purpose-draft:';
let watched = false;
function clearDrafts() {
  try {
    for (const key of Object.keys(sessionStorage))
      if (key.startsWith(PREFIX)) sessionStorage.removeItem(key);
  } catch {
    /* storage may be disabled */
  }
}
export function draftKey(object: string): string {
  return `${PREFIX}${auth.currentUser?.uid ?? 'session'}:${getActiveContext()?.tenantId ?? ''}:${getActiveContext()?.organizationId ?? ''}:${object}`;
}
function watch() {
  if (watched) return;
  watched = true;
  const user = auth.currentUser?.uid;
  let context = JSON.stringify(getActiveContext());
  onAuthStateChanged(auth, (next) => {
    if (next?.uid !== user) clearDrafts();
  });
  subscribe(() => {
    const next = JSON.stringify(getActiveContext());
    if (next !== context) clearDrafts();
    context = next;
  });
}
export function readDraft(key: string): unknown {
  watch();
  try {
    const value = sessionStorage.getItem(key);
    return value ? (JSON.parse(value) as unknown) : null;
  } catch {
    return null;
  }
}
export function writeDraft(key: string, value: unknown) {
  watch();
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* the current form still works */
  }
}
export function removeDraft(key: string) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* optional browser storage */
  }
}
